module.exports = __webpack_public_path__ + "img/logo-plus.5601455c.png";